import classNames from 'classnames';
import React from 'react';
import styles from './link.css';

export function Link({
  href,
  onClick,
  target = '_blank',
  download,
  children,
  clickOnMount,
  subtle,
}: {
  target?: React.HTMLAttributeAnchorTarget;
  download?: string;
  children: React.ReactNode;
  clickOnMount?: boolean;
  subtle?: boolean;
} & (
  | {
      href: string;
      onClick?: undefined;
    }
  | {
      href?: undefined;
      onClick: () => void;
    }
)) {
  const ref = React.useRef<HTMLAnchorElement>(null);
  React.useEffect(() => {
    if (clickOnMount && ref.current) {
      ref.current.click();
    }
  }, []);

  const handleClick = React.useMemo(() => {
    if (!onClick) {
      return undefined;
    }
    return (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      onClick();
    };
  }, [onClick]);

  return (
    <a
      className={classNames(styles.link, subtle && styles.isSubtle)}
      href={href || '#'}
      onClick={handleClick}
      target={target}
      download={download}
      ref={ref}
    >
      {children}
    </a>
  );
}
